import { render, staticRenderFns } from "./global-navigation.vue?vue&type=template&id=2a65bbde&scoped=true"
import script from "./global-navigation.vue?vue&type=script&lang=js"
export * from "./global-navigation.vue?vue&type=script&lang=js"
import style0 from "./global-navigation.vue?vue&type=style&index=0&id=2a65bbde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a65bbde",
  null
  
)

export default component.exports